

export const APP_ENV = process.env.REACT_APP_ENVIRONMENT;
export const APP_VERSION = process.env.REACT_APP_VERSION;


export const TVS_ACCESS_TOKEN = "TVS_A_T";

//App routes
export const LOGIN = "/login";
export const LANDING = "/landing-page";
export const ERROR = LOGIN + "/error";


export const CONFIGURATION_DASHBOARD = "/configuration-dashboard";
export const CONFIGURATION_GROUPS =  CONFIGURATION_DASHBOARD + "/electrical";
// export const CONFIGURATION_SUBGROUPS =  CONFIGURATION_DASHBOARD +"/steam-grouping";
// export const CONFIGURATION_GROUP_METER_CONFIG =  CONFIGURATION_DASHBOARD +"/water-grouping";


export const CONFIGURATION_CONVERTER =  CONFIGURATION_DASHBOARD + "/Converter-config";
export const CONFIGURATION_METER =  CONFIGURATION_DASHBOARD + "/Device-config";
export const CONFIGURATION_USER =  CONFIGURATION_DASHBOARD + "/User-registration";
export const CONFIGURATION_GROUP =  CONFIGURATION_DASHBOARD + "/Group-config/group";
export const CONFIGURATION_SUB_GROUP =  CONFIGURATION_DASHBOARD + "/Group-config/sub-group";
export const CONFIGURATION_GROUP_METER =  CONFIGURATION_DASHBOARD + "/Group-config/group-meter";
export const CONFIGURATION_STEAM_GROUP =  CONFIGURATION_DASHBOARD + "/Steam-grouping/group";
export const CONFIGURATION_STEAM_SUB_GROUP =  CONFIGURATION_DASHBOARD + "/Steam-grouping/sub-group";
export const CONFIGURATION_STEAM_GROUP_METER =  CONFIGURATION_DASHBOARD + "/Steam-grouping/group-meter";
export const CONFIGURATION_WATER_GROUP =  CONFIGURATION_DASHBOARD + "/Water-grouping/group";
export const CONFIGURATION_WATER_SUB_GROUP =  CONFIGURATION_DASHBOARD + "/Water-grouping/sub-group";
export const CONFIGURATION_WATER_GROUP_METER =  CONFIGURATION_DASHBOARD + "/Water-grouping/group-meter";



// Electrical layout

export const ELECTRICAL_DASHBOARD = "/electrical-dashboard";
export const ORG_CHART_ELECTRICAL =  ELECTRICAL_DASHBOARD + "/tree-chart";
export const PLANT_FORM =   ELECTRICAL_DASHBOARD + "/plant-form";
export const COMBINED_CHART =  ELECTRICAL_DASHBOARD + "/combined-chart";


//Steam Layout

export const STEAM_DASHBOARD = "/steam-dashboard";


//temperature 

export const TEMPERATURE_DASHBOARD = "/temperature-dashboard";
export const PLANT_FORM_TEMPERATURE =  TEMPERATURE_DASHBOARD+ "/plant-form";
export const ORG_CHART_TEMPERATURE =  TEMPERATURE_DASHBOARD + "/tree-chart";

//Air
export const AIR_DASHBOARD = "/air-dashboard";
export const PLANT_FORM_AIR =  AIR_DASHBOARD + "/plant-form";

//Water
export const WATER_DASHBOARD = "/water-dashboard";
export const PLANT_FORM_WATER =  WATER_DASHBOARD + "/plant-form";

export const UNAUTHORIZED_PATH =  "/unauthorized-access";
export const AR_NO_MATCH = "*";


export const Messages = {
    LOADING: "Loading...",
   FETCH_DATA: "data fetched successfully",
   SAVE_DATA:"data saved successfully",
   UPDATE_DATA: "data updated successfully",
   DELETE_DATA:"data deleted successfully"

  };






